// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-icon {
	position: fixed;
	z-index: 8001;
	right: 0.5rem;
	top: 0.5rem;
	color: white;
}
.settings-menu {
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: 8009;
	align-items: flex-end;

	top: 3.5rem;
	right: 0rem;
	animation: appear 0.3s;
	/* width: 50px; */
	line-height: 1.5rem;
}

.settings-menu.links {
	display: flex;
	flex-direction: column;
	animation: menu-slide-out-to-top-right 0.1s ease-in;
	padding: 0.2rem 0.2rem;
	color: var(--primary-color1);
	/* min-width: 20rem; */
	z-index: 8003;
	background-color: var(--neutral-color1-0p8);
	border-radius: 2rem;
	box-shadow: 0px 0px 5px 1px;
}

@media (min-width: 500px) {
	.settings-menu {
		align-items: flex-end;
		display: flex;
		flex-direction: column;
		z-index: 8009;
		animation: appear 0.1s;
		line-height: 1.5rem;
		border-radius: 2rem;
	}

	.settings-menu.links {
		display: flex;
		flex-direction: column;
		animation: appear 0.2s ease-in;
		padding: 1rem 1rem;
		color: var(--primary-color1);
		min-width: 0;
		z-index: 8003;
	}

	.setting-icon {
		position: absolute;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		z-index: 8001;
		left: 0rem;
		top: 0rem;
		width: 25rem;
		color: black;
		/* background:  url('../assets/icons/icons8-settings-50.png') contain white; */
	}
	.setting-icon svg {
		color: black !important;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/IconMenu.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,aAAa;CACb,aAAa;CACb,WAAW;CACX,YAAY;AACb;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,aAAa;CACb,qBAAqB;;CAErB,WAAW;CACX,WAAW;CACX,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mDAAmD;CACnD,sBAAsB;CACtB,4BAA4B;CAC5B,sBAAsB;CACtB,aAAa;CACb,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC;EACC,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,8EAA8E;CAC/E;CACA;EACC,uBAAuB;CACxB;AACD","sourcesContent":[".setting-icon {\n\tposition: fixed;\n\tz-index: 8001;\n\tright: 0.5rem;\n\ttop: 0.5rem;\n\tcolor: white;\n}\n.settings-menu {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tz-index: 8009;\n\talign-items: flex-end;\n\n\ttop: 3.5rem;\n\tright: 0rem;\n\tanimation: appear 0.3s;\n\t/* width: 50px; */\n\tline-height: 1.5rem;\n}\n\n.settings-menu.links {\n\tdisplay: flex;\n\tflex-direction: column;\n\tanimation: menu-slide-out-to-top-right 0.1s ease-in;\n\tpadding: 0.2rem 0.2rem;\n\tcolor: var(--primary-color1);\n\t/* min-width: 20rem; */\n\tz-index: 8003;\n\tbackground-color: var(--neutral-color1-0p8);\n\tborder-radius: 2rem;\n\tbox-shadow: 0px 0px 5px 1px;\n}\n\n@media (min-width: 500px) {\n\t.settings-menu {\n\t\talign-items: flex-end;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tz-index: 8009;\n\t\tanimation: appear 0.1s;\n\t\tline-height: 1.5rem;\n\t\tborder-radius: 2rem;\n\t}\n\n\t.settings-menu.links {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tanimation: appear 0.2s ease-in;\n\t\tpadding: 1rem 1rem;\n\t\tcolor: var(--primary-color1);\n\t\tmin-width: 0;\n\t\tz-index: 8003;\n\t}\n\n\t.setting-icon {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\t\tz-index: 8001;\n\t\tleft: 0rem;\n\t\ttop: 0rem;\n\t\twidth: 25rem;\n\t\tcolor: black;\n\t\t/* background:  url('../assets/icons/icons8-settings-50.png') contain white; */\n\t}\n\t.setting-icon svg {\n\t\tcolor: black !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
